export enum LeadRequestStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface LeadClaimRequest {
  _id: string;
  leadTelegramId: string;
  leadTelegramUsername: string;
  user: string;
  leadLink: string;
  moderator: string;
  curator: string;
  attachments: string[];
  status: LeadRequestStatus;
  createdAt: Date;
  updatedAt: Date;
}
